import React from 'react';
import { connect } from 'react-redux';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import LoaderWhite from 'components/LoaderWhite';
import SearchBox from 'components/SearchBox';
import TrackCollections from 'components/TrackCollections';
import BrowseByGenre from 'components/BrowseByGenre';
import CuratedForYou from 'components/CuratedForYou';
import { updateProviderTracks } from 'store/actions/providerTracksActions';
import {
  getNewReleases,
  getTrendingTracks,
  getFeaturedTracks,
} from 'services/providerService';

const providerFn = {
  releases: getNewReleases,
  trending: getTrendingTracks,
  featured: getFeaturedTracks,
};

const Discover = ({
  uid,
  firstName,
  favoriteGenres,
  providerTracks,
  updateProviderTracks,
}) => {
  const getProviderTracks = async (type) => {
    try {
      const listInState = providerTracks[type];
      // Simply return the list saved in the app state if any
      if (listInState && listInState.length) return listInState;
      // Request from provider
      const tracks = await providerFn[type]();
      // Update the app state with the track list just fetched
      updateProviderTracks({ type, tracks });
    } catch (error) {
      // TODO: handle error
      console.log(error);
    }
  };

  return uid ? (
    <GridContainer>
      <GridItem xs={12}>
        <SearchBox />
      </GridItem>
      <GridItem xs={12}>
        <GridContainer style={{ color: 'white' }}>
          <GridItem style={{ color: 'white', margin: '0px auto' }}>
            <h3> Hello {firstName}</h3>
            <h6 style={{ margin: '-10px 0px -10px -20px' }}>
              {' '}
              Discover What's New in Music{' '}
            </h6>
          </GridItem>
          <GridItem
            style={{
              margin: '0px -30px 0px -30px',
              width: '117%',
            }}
          >
            <TrackCollections
              tracks={providerTracks}
              onSelect={getProviderTracks}
            />
            {!!favoriteGenres.length && (
              <div style={{ margin: '-33px 0px 10px 0px' }}>
                <CuratedForYou />
              </div>
            )}
            <BrowseByGenre />
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  ) : (
    <LoaderWhite />
  );
};

Discover.defaultProps = {
  favoriteGenres: [],
};

const mapStateToProps = (state) => {
  const { user, providerTracks } = state;
  const { uid, favoriteGenres, firstName } = user;
  return { uid, favoriteGenres, firstName, providerTracks };
};

export default connect(mapStateToProps, { updateProviderTracks })(Discover);
